import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { 
  Box, 
  Chip, 
  CircularProgress,  
  IconButton,  
  Table, 
  TableBody, 
  TableCell, 
  TableFooter, 
  TableHead, 
  TablePagination, 
  TableRow, 
  TableSortLabel, 
  Tooltip, 
  Typography 
} from '@mui/material';

import TablePaginationActions from '../../../../../components/utils/TablePaginationActions';
import useTablePaginationInit from '../../../../../components/hooks/useTablePaginationInit';
import TableTimeStamps from '../../../../../components/utils/TableTimeStamps';
import Copyable from '../../../../../components/utils/Copyable';
import TopBar from '../../../../../components/utils/TopBar';
import NA from '../../../../../components/utils/NA';

import LoginOutlinedIcon from '@mui/icons-material/LoginOutlined';
import { 
  SELECT_ACCOUNT_BIZ_FUSION_CC 
} from '../../../../../redux/actionTypes';

import global from "../../../../../global.scss";

const ContactsPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const state = useSelector(state => state["business.fusion.cc"]);
  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(false);
  const [sort, setSort] = useState("created_at");
  const [sortDirection, setSortDirection] = useState("desc");

  const [contactsList, setContactsList] = useState([]);
  const [contactsTotal, setContactsTotal] = useState(0);

  const [
    page, 
    rowsPerPage, 
    handleChangePage, 
    handleChangeRowsPerPage
  ] = useTablePaginationInit();

// {
//     "loginId": "rimi_lusid",
//     "id": "0425ddb3-32d9-4815-b9e6-8ac78b5916ab",
//     "firstName": "Rimi",
//     "lastName": "Chowdhry",

//     "status": "enabled",

//     "emailAddress": "rimi@lusid.ai",
//     "mobilePhoneNumber": "",
//     "phoneNumber": "rimi@lusid.ai",


//     "createdAt": "2024-11-15T19:50:51+00:00",
//     "updatedAt": "2024-11-15T19:50:51+00:00"
// }

  const tableHeadingsList = [
    {
      label: "Id",
      sort: null,
    },
    {
      label: "Name",
      sort: null,
    },
    // {
    //   label: "Payment types",
    //   sort: null,
    // },
    // {
    //   label: "Beneficiary address",
    //   sort: null,
    // }, 
    // {
    //   label: "Currency",
    //   sort: null,
    // },
    {
      label: "Email",
      sort: null,
    },
    {
      label: "Mobile",
      sort: null,
    },
    {
      label: "Phone",
      sort: null,
    },
    {
      label: "Status",
      sort: null,
    },
    {
      label: "Time stamps",
      sort: null,
    },
    {
      label: "",
      sort: null,
    }
  ];

  const handleSort = (value) => {
    setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    setSort(value);
  };

  useEffect(() => {
  
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, rowsPerPage, sort, sortDirection]);

  useEffect(() => {
    try {
      formatContactsList(state.contactsList.records || []);
      setContactsTotal(state.contactsList.total || 0);
    } catch (err) {}
  }, [state]);

  const formatContactsList = (list) => {
    setContactsList(list);
  };

  const handleSelectContact = (row) => {
    let obj = {
        ...state.selectedAccount, 
        contact: row
    };
    dispatch({ type: SELECT_ACCOUNT_BIZ_FUSION_CC, payload: obj });
    navigate("/business/fusion/currency-cloud/beneficiaries");
  };

  return (
    <Box>

      <TopBar
        title={"Contacts"}
        />

      {
        loading
        ?
        <Box height={"300px"} className="flexCenterCenterRow">
          <CircularProgress />
        </Box>
        :
          contactsList.length === 0
          ?
          <Box height={"300px"} className="flexCenterCenterRow">
            <Typography>No contact found</Typography>
          </Box>
          :
          <Table className="block">
            <TableHead>
              <TableRow>
                {
                  tableHeadingsList.map((heading, headingIndex) => (
                    heading.sort === null
                    ?
                    <TableCell
                      key={headingIndex}>{heading.label}</TableCell>
                    :
                    <TableCell
                      key={headingIndex}>
                      <TableSortLabel
                        active={sort === heading.sort ? true : false}
                        direction={sortDirection}
                        onClick={() => {
                          handleSort(heading.sort);
                        }}
                      >
                        {heading.label}
                      </TableSortLabel>
                    </TableCell>
                  ))
                }
              </TableRow>
            </TableHead>
            <TableBody>
              {
                contactsList.map((row, index) => (
                  <TableRow 
                    key={index}
                    className='table__clickable-row'
                    onClick={() => handleSelectContact(row)}>
                    <TableCell>
                      <Typography
                        variant='caption'
                        color={"grey"}>
                        <Copyable>
                          {row.id}
                        </Copyable>
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Box>
                        {row.firstName + " " + row.lastName || <NA />}
                      </Box>
                      <Tooltip
                        title="LoginId">
                        <Box>
                          <Typography
                            variant='caption'
                            color={"grey"}>
                            {row.loginId || <NA />}
                          </Typography>
                        </Box>
                      </Tooltip>
                    </TableCell>
                    <TableCell>
                      <Typography
                        variant='caption'>
                        <Copyable>
                          {row.emailAddress || <NA />}
                        </Copyable>
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        variant='caption'>
                        <Copyable>
                          {row.mobilePhoneNumber || <NA />}
                        </Copyable>
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        variant='caption'>
                        <Copyable>
                          {row.phoneNumber || <NA />}
                        </Copyable>
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Chip
                        size='small'
                        color={row.status === "enabled" ? 'success' : 'error'}
                        label={row.status || <NA />}>
                      </Chip>
										</TableCell>
                    <TableCell>
                      <TableTimeStamps
                        createdAt={row.createdAt}
                        updatedAt={row.updatedAt}
                        />
                    </TableCell>
                    <TableCell>
                      <IconButton>
                        <LoginOutlinedIcon sx={{ color: global['secondary_light'] }}/>
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              }
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  sx={{ borderBottom: 0 }}
                   rowsPerPageOptions={[5, 10, 25, 50, 100]} 
                  colSpan={10}
                  count={contactsTotal}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  SelectProps={{
                    inputProps: {
                      'aria-label': 'rows per page'
                    },
                    native: true
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                  />
              </TableRow>
            </TableFooter>
          </Table>
      }
    </Box>
  )
}

export default ContactsPage;